import { render, staticRenderFns } from "./SInfoCloseBoxComp.vue?vue&type=template&id=26d2c5b4&"
import script from "./SInfoCloseBoxComp.vue?vue&type=script&lang=js&"
export * from "./SInfoCloseBoxComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports